// extracted by mini-css-extract-plugin
export default {"container":"u2gQ1RTmVgtgapqQxEJc","labelContainer":"B0gpJsC5hpc2AkI2zMB_","colorPaletteContainer":"tg32FUDb0ccisH8bubjX","icon":"Qh7dq6ORiaHYM00MZLLk"};